import { addDaysToDateKey, localDateKey } from '../dateKey';

export function circleDayLabel(dateKey: string, today = localDateKey()): string {
  if (dateKey === today) return 'Today';
  if (dateKey === addDaysToDateKey(today, -1)) return 'Yesterday';
  return new Date(`${dateKey}T12:00:00`).toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
  });
}

export function circleDayShortLabel(dateKey: string, today = localDateKey()): string {
  if (dateKey === today) return 'Today';
  if (dateKey === addDaysToDateKey(today, -1)) return 'Yday';
  return new Date(`${dateKey}T12:00:00`).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'numeric',
    day: 'numeric',
  });
}

/** Last N calendar days ending today (oldest first). */
export function circleRecentDayKeys(count = 7, today = localDateKey()): string[] {
  return Array.from({ length: count }, (_, i) => addDaysToDateKey(today, i - count + 1));
}
